import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { FormField } from '../../../molecules'
import type { ApplicationTabProps } from '../applicationFormTypes'

export const ApplicationVersionTab = memo(
  ({ values, errors, onChange, skeleton }: ApplicationTabProps) => {
    const { t } = useTranslation('admin-mobifull')
    return (
      <fieldset className="form-group form-fieldset">
        <legend>{t('applications.form.versionGateLegend')}</legend>
        <FormField
          skeleton={skeleton}
          id="app-min-version"
          label={t('applications.form.minVersionLabel')}
          name="min_version"
          value={values.minVersion}
          onChange={e => onChange('minVersion', e.target.value)}
          error={errors.minVersion}
          placeholder="1.2.0"
          autoComplete="off"
          spellCheck={false}
          hint={t('applications.form.minVersionHint')}
        />
        <FormField
          skeleton={skeleton}
          id="app-latest-version"
          label={t('applications.form.latestVersionLabel')}
          name="latest_version"
          value={values.latestVersion}
          onChange={e => onChange('latestVersion', e.target.value)}
          error={errors.latestVersion}
          placeholder="1.2.0"
          autoComplete="off"
          spellCheck={false}
          hint={t('applications.form.latestVersionHint')}
        />
        <FormField
          skeleton={skeleton}
          id="app-store-url-android"
          label={t('applications.form.storeUrlAndroidLabel')}
          name="store_url_android"
          value={values.storeUrlAndroid}
          onChange={e => onChange('storeUrlAndroid', e.target.value)}
          error={errors.storeUrlAndroid}
          type="url"
          inputMode="url"
          autoComplete="off"
          spellCheck={false}
          placeholder="https://play.google.com/store/apps/details?id=..."
          hint={t('applications.form.storeUrlAndroidHint')}
        />
        <FormField
          skeleton={skeleton}
          id="app-store-url-ios"
          label={t('applications.form.storeUrlIosLabel')}
          name="store_url_ios"
          value={values.storeUrlIos}
          onChange={e => onChange('storeUrlIos', e.target.value)}
          error={errors.storeUrlIos}
          type="url"
          inputMode="url"
          autoComplete="off"
          spellCheck={false}
          placeholder="https://apps.apple.com/app/id..."
          hint={t('applications.form.storeUrlIosHint')}
        />
        <FormField
          skeleton={skeleton}
          id="app-api-base-url"
          label={t('applications.form.apiBaseUrlLabel')}
          name="api_base_url"
          value={values.apiBaseUrl}
          onChange={e => onChange('apiBaseUrl', e.target.value)}
          error={errors.apiBaseUrl}
          type="url"
          inputMode="url"
          autoComplete="off"
          spellCheck={false}
          placeholder="https://api.adm.mobifull.app"
          hint={t('applications.form.apiBaseUrlHint')}
        />
        <FormField
          skeleton={skeleton}
          id="app-image-base-url"
          label={t('applications.form.imageBaseUrlLabel')}
          name="image_base_url"
          value={values.imageBaseUrl}
          onChange={e => onChange('imageBaseUrl', e.target.value)}
          error={errors.imageBaseUrl}
          type="url"
          inputMode="url"
          autoComplete="off"
          spellCheck={false}
          placeholder="https://api.adm.mobifull.app"
          hint={t('applications.form.imageBaseUrlHint')}
        />
      </fieldset>
    )
  },
)

ApplicationVersionTab.displayName = 'ApplicationVersionTab'
